import { PostCardStack } from './post-card-stack';
import type { CardData } from '../../../../print-cards/card-data';
import { Type } from '@angular/core';
import { CardBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/card-background.component';
import { PrintCardContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/shared/print-card-content.component';
import { DougPostCardStackContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/post-cards-4x6/doug-post-card-stack-content/doug-post-card-stack-content.component';
import { DougPostCardStackBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/post-cards-4x6/doug-post-card-stack-background/doug-post-card-stack-background.component';

export class DougPostCardStack extends PostCardStack {
  getCardBackgroundComponent(cardData: CardData): Type<CardBackgroundComponent> | null {
    return DougPostCardStackBackgroundComponent;
  }

  getCardContentComponent(cardData: CardData): Type<PrintCardContentComponent> | null {
    return DougPostCardStackContentComponent;
  }

  nonPerforatedBleedBorderInInches(): number {
    return 0;
  }
}
